export var FeatureFlagsActionKind;
(function (FeatureFlagsActionKind) {
    FeatureFlagsActionKind["GetFeatureFlagsSettings"] = "GetFeatureFlagsSettings";
})(FeatureFlagsActionKind || (FeatureFlagsActionKind = {}));
